<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- 基础信息 -->
    <el-card class="box-card">
      <div slot="header" class="card-header">
        <h3 class="card-title titleCont">
          <span class="spIcon"></span>
          查看专业
        </h3>
      </div>
      <div class="card-body">
        <el-row :gutter="20" class="pl-5 pr-5">
          <el-col :lg="8" :md="12" :sm="24" class="colInfo">
            <label>专业名称</label>
            <div class="colFonts">
              {{ ruleForm.name | nullData }}
            </div>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" class="colInfo">
            <label>招生专业代码</label>
            <div class="colFonts">
              {{ ruleForm.code | nullData }}
            </div>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" class="colInfo">
            <label>批次</label>
            <div class="colFonts">
              {{ ruleForm.batch | nullData }}
            </div>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" class="colInfo">
            <label>办学层次</label>
            <div class="colFonts">
              {{ ruleForm.bxccStr | nullData }}
            </div>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" class="colInfo">
            <label>培养目标</label>
            <div class="colFonts">
              {{ ruleForm.pymmStr | nullData }}
            </div>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" class="colInfo">
            <label>学制</label>
            <div class="colFonts">
              {{ ruleForm.xz | nullData }}
            </div>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" class="colInfo">
            <label>计划数</label>
            <div class="colFonts">
              {{ ruleForm.planCount | nullData }}
            </div>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" class="colInfo">
            <label>学费</label>
            <div class="colFonts">
              {{ ruleForm.tuitionFee | nullData }}
            </div>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" class="colInfo">
            <label>代办费</label>
            <div class="colFonts">
              {{ ruleForm.agencyFee | nullData }}
            </div>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" class="colInfo">
            <label>住宿费</label>
            <div class="colFonts">
              {{ ruleForm.accommodationFee | nullData }}
            </div>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" class="colInfo">
            <label>保险费</label>
            <div class="colFonts">
              {{ ruleForm.insuranceFee | nullData }}
            </div>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" class="colInfo">
            <label>显示优先级</label>
            <div class="colFonts">
              {{ ruleForm.priority | nullData }}
            </div>
          </el-col>
          <el-col :span="24" class="colInfo">
            <label>备注</label>
            <div class="colFonts">
              {{ ruleForm.remark | nullData}}
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <div class="pt-10">
      <el-button icon="el-icon-back" @click="onBack()">返回</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        fullscreenLoading: false,
        Title: "查看专业",
        // 数据
        ruleForm: {
          majorId: null,
          code: null,
          name: null,
          batchId: null,
          bxcc: null,
          pymm: null,
          xz: null,
          planCount: null,
          tuitionFee: null,
          agencyFee: null,
          accommodationFee: null,
          insuranceFee: null,
          priority: null,
          remark: null,
        },

      }
    },
    created() {
      let that = this;
      let id = that.$route.params.id;
      that.ruleForm.majorId = id;
      that.fullscreenLoading = true;
      ajaxGet(that, "/api/admin/enrollmajor/" + id, null, function(res) {
        that.ruleForm = res;
        that.fullscreenLoading = false;
      })

    },
    methods: {
      onBack() {
        back(this);
      },
    }
  }
</script>

<style lang="less" scoped>

</style>
